export default __webpack_public_path__ + "static/media/item_6@3x.3c3dc2c4.png";